<template>
    <div class="block-editor cache-read">
        <div class="wrapper">
            <!-- Cache Key -->
            <section>
                <div class="title">{{ $t("Cache Key") }}</div>
                <TiptapEditor
                    :placeholder="$t('Okunacak cache key')"
                    :show-attributes="true"
                    v-model="clone.key"
                    automation-mode
                />
                <div class="help-text">
                    <i class="material-icons">info</i>
                    <span>Okumak istediğiniz cache'in key'ini girin.</span>
                </div>
            </section>

            <!-- Default Value -->
            <section>
                <div class="title">{{ $t("Default Value (Cache bulunamazsa)") }}</div>
                <TiptapEditor
                    :placeholder="$t('Cache bulunamazsa veya expire olduysa bu değer döndürülür')"
                    :show-attributes="true"
                    v-model="clone.defaultValue"
                    automation-mode
                />
                <div class="help-text">
                    <i class="material-icons">lightbulb</i>
                    <span>Cache bulunamazsa veya expire olduysa bu değer döndürülür. Boş bırakılırsa null döner.</span>
                </div>
            </section>

            <!-- Output Info -->
            <section>
                <div class="output-info">
                    <div class="info-title">
                        <i class="material-icons">output</i>
                        <span>Çıktı Bilgisi</span>
                    </div>
                    <div class="output-attributes">
                        <div class="attribute-item">
                            <code>block.{{'{'}}{'{blockId}'}}.value</code>
                            <span>Cache değeri veya default value</span>
                        </div>
                        <div class="attribute-item">
                            <code>block.{{'{'}}{'{blockId}'}}.found</code>
                            <span>Cache bulundu mu? (boolean)</span>
                        </div>
                        <div class="attribute-item">
                            <code>block.{{'{'}}{'{blockId}'}}.success</code>
                            <span>İşlem başarılı mı?</span>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

export default {
    name: "CacheRead",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value || {
                key: "",
                defaultValue: "",
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.cache-read {
    .wrapper {
        padding: 30px;

        section {
            margin-bottom: 20px;

            .title {
                margin-bottom: 10px;
                font-weight: 600;
                font-size: 16px;
                line-height: 20px;
            }

            .help-text {
                display: flex;
                align-items: flex-start;
                gap: 8px;
                margin-top: 8px;
                padding: 10px;
                background: #f0f8ff;
                border-radius: 6px;
                font-size: 13px;
                color: #666;

                .material-icons {
                    font-size: 18px;
                    color: #1890ff;
                }
            }

            .output-info {
                background: #f8f9fa;
                border-radius: 8px;
                padding: 15px;
                border-left: 3px solid #28a745;

                .info-title {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-weight: 600;
                    margin-bottom: 12px;
                    color: #28a745;

                    .material-icons {
                        font-size: 20px;
                    }
                }

                .output-attributes {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;

                    .attribute-item {
                        display: flex;
                        flex-direction: column;
                        gap: 4px;

                        code {
                            background: #e9ecef;
                            padding: 4px 8px;
                            border-radius: 4px;
                            font-size: 13px;
                            color: #d63384;
                        }

                        span {
                            font-size: 12px;
                            color: #666;
                        }
                    }
                }
            }
        }
    }
}
</style>


